import { ROUTES } from '@monofront/business/constants';
import { RoutesEnum } from '@monofront/types';
import useI18n from './useI18n';

const useLocalizedRoutes = () => {
  const { locale, channel } = useI18n();

  const getPath = (pageCode: RoutesEnum) => {
    let path = '';

    try {
      path = ROUTES[pageCode][locale].path;
    } catch (e) {
      console.error(
        `Cannot find localized path ${pageCode} for ${channel} channel.`,
      );
    }

    return path;
  };
  const getUrl = (pageCode: RoutesEnum) => {
    let url = '';

    try {
      url = ROUTES[pageCode][locale].url;
    } catch (e) {
      console.error(
        `Cannot find localized url ${pageCode} for ${channel} channel.`,
      );
    }

    return url;
  };

  return {
    getPath,
    getUrl,
  };
};

export default useLocalizedRoutes;
